import { render } from "./vrecagent.vue?vue&type=template&id=76cd21fd&scoped=true"
import script from "./vrecagent.vue?vue&type=script&lang=js"
export * from "./vrecagent.vue?vue&type=script&lang=js"

import "./vrecagent.vue?vue&type=style&index=0&id=76cd21fd&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76cd21fd"]])

export default __exports__